import type { EditorCapabilities } from "../../editor/types";
import Dropdown from "./Dropdown";
import type { MentionSuggestion } from "./types";
import useMention from "./useMention";

export type MentionsProps = {
  mentions: Record<string, unknown[]>;
  capabilities: EditorCapabilities;
  fullMentionLinks?: boolean;

  // Does not directly return mentions but just acts as a trigger to load mentions which are passed in via state
  onSuggest: (kind: Array<string>, query: string) => void;
  onMentionSelect?: (mention: MentionSuggestion) => void;
};

const Mentions = ({
  mentions,
  capabilities,
  fullMentionLinks,
  onSuggest,
  onMentionSelect,
}: MentionsProps) => {
  const mentionProps = useMention({
    rawMentions: mentions,
    configs: capabilities.mentions ?? [],
    emojiEnabled: !!capabilities.emoji,
    fullMentionLinks: !!fullMentionLinks,
    onSuggest,
    onMentionSelect,
  });

  return <Dropdown {...mentionProps} />;
};

export default Mentions;
